"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "formatNumberToCurrency", {
    enumerable: true,
    get: function() {
        return formatNumberToCurrency;
    }
});
const _validation = require("../utils/validation");
const formatNumberToCurrency = (num)=>{
    if (!(0, _validation.isNumeric)(num)) return '';
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    const formattedNumber = formatter.format(num / 100);
    return formattedNumber;
};

//# sourceMappingURL=transaction-amount.js.map